<template>
  <div class="moreSearch">
    <el-popover
      placement="bottom-start"
      width="558"
      trigger="click"
      popper-class="my-popover"
      v-model="visible"
      ref="popover"
      @show="showPopver"
    >
      <div class="lyout" @click="tags = false">
        <div class="cond">
          <el-button @click="addBut" v-if="addButt">添加筛选条件</el-button>
        </div>
        <div class="main" v-if="!addButt">
          <div
            class="main-first"
            v-for="(item, index) in searchJson"
            :key="index"
          >
            <div class="sele-fist">
              <!-- 前面 v-el-select-loadmore="loadMore(rangeNumber)"-->
              <el-select
                v-model="item.key"
                @focus="focusChange(item)"
                @change="selectChange(item, $event)"
                placeholder="请选择"
                filterable
                remote
                :remote-method="(query) => {filterMethod(query, item)}"
              >
                <el-option
                  v-for="key in item.optionsKey"
                  :key="key.prop"
                  :label="key.label"
                  :value="key.prop"
                />
              </el-select>
            </div>
            <!-- 后面 -->
            <div class="sele-secon" v-if="item.type === '10' || item.type === '11' || item.type === '15'">
              <!-- 标签 item.key === 'label'-->
              <div
                v-if="item.type === '15'"
                class="input_box"
                @click.stop="labelChange(item.date)"
              >
                <el-popover
                  placement="bottom"
                  width="540"
                  trigger="click"
                  v-model="tags"
                >
                  <TagsList :tags-objects="tagsObject" :tag-lists="tagList" />
                  <div class="input" slot="reference">
                    <div
                      v-for="(date, label_user) in item.labelList"
                      :key="date.id"
                      style="margin-right: 3px"
                    >
                      <span>{{date.labelName}}</span>
                      <span
                        v-if="item.labelList.length - 1 != label_user"
                      >,</span>
                    </div>
                  </div>
                </el-popover>
              </div>
              <!-- 人 -->
              <div v-if="item.type === '10' || item.type === '11'" class="input_box">
                <div @click="contactCh(item.userList, item)" class="input" v-if="channel === 'ding'">
                  <div
                    v-for="(date, user_index) in item.userList"
                    :key="date.id"
                    style="margin-right: 3px"
                  >
                    <span>{{date.name}}</span>
                    <span v-if="item.userList.length - 1 != user_index">,</span>
                  </div>
                </div>
                <div @click="contactCh(item.userList, item)" class="input" v-if="channel === 'wechat'">
                  <div
                    v-for="(date, user_index) in item.userList"
                    :key="date.id"
                    style="margin-right: 3px"
                  >
                    <span>
                      <ww-open-data type="userName" :openid="date.name" />
                    </span>
                    <span v-if="item.userList.length - 1 != user_index">,</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="sele-secon" v-else>
              <!--  item.type === '0'-->
              <div v-if="item.type === '0'">
                <div v-if="item.optionsValue.sysFlag === '1'">
                  <!-- @focus="getFromList" -->
                  <div v-if="item.optionsValue.prop === 'formName'">
                    <el-select
                      v-model="item.date"
                      placeholder="请选择"
                      @change="selectChange1(item)"
                      @focus="getFromList"
                      multiple
                      collapse-tags
                      filterable
                      style="width: 222px;"
                    >
                      <el-option
                        v-for="value in fromList"
                        :key="value.id"
                        :label="value.formName"
                        :value="value.id"
                      />
                    </el-select>
                  </div>
                  <div v-else-if="item.optionsValue.prop === 'projectName'">
                    <el-select
                      v-model="item.date"
                      placeholder="请选择"
                      @change="selectChange1(item)"
                      multiple
                      popper-class="selectStyle"
                      collapse-tags
                      filterable
                      style="width: 222px;"
                    >
                      <el-option
                        v-for="value in proList"
                        :key="value.id"
                        :label="value.proname"
                        :value="value.id"
                      />
                    </el-select>
                  </div>
                  <div v-else-if="item.optionsValue.prop === 'flowName'">
                    <!-- @focus="getChoiceList" -->
                    <el-select
                      v-model="item.date"
                      placeholder="请选择"
                      @change="selectChange1(item)"
                      multiple
                      collapse-tags
                      filterable
                      style="width: 222px;"
                    >
                      <el-option
                        v-for="value in flowList"
                        :key="value.id"
                        :label="value.flowName"
                        :value="value.id"
                      />
                    </el-select>
                  </div>
                  <div v-else-if="item.optionsValue.prop === 'flowNames'">
                    <el-cascader
                      class="user-cascader"
                      :options="item.flowList"
                      collapse-tags
                      filterable
                      v-model="item.date"
                      @change="selectChange1(item)"
                      :props="cascaderProps"
                      popper-class="node"
                      style="width: 222px;"
                    />
                  </div>
                  <div v-else>
                    <el-input v-model="item.value" placeholder="请输入" :autofocus="true" />
                  </div>
                </div>
                <div v-else-if="item.optionsValue.sysFlag !== '1'">
                  <el-input v-model="item.value" placeholder="请输入" :autofocus="true" />
                </div>
              </div>
              <!--  item.type === '1'-->
              <div v-if="item.type === '1' || item.type === '16'" style="display: flex;" class="felx">
                <el-input
                  style="width: 100px;"
                  v-model="item.date[0]"
                  placeholder="最小值"
                  type="number"
                  @input="selectChange1(item)"
                  min="0"
                  max="999999"
                  :autofocus="true"
                  oninput="if(isNaN(value)) { value = parseFloat(value) } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                />
                <div class="center" style="margin: 0 5px;">
                  <span>至</span>
                </div>
                <el-input
                  style="width: 100px;"
                  v-model="item.date[1]"
                  placeholder="最大值"
                  type="number"
                  :autofocus="true"
                  min="0"
                  max="999999"
                  @input="selectChange1(item)"
                  oninput="if(isNaN(value)) { value = parseFloat(value) } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                />
              </div>
              <!--  item.type === '2'-->
              <div v-if="item.type === '2' || item.type === '5' || item.type === '12'" class="input-area">
                <el-input
                  v-model="item.value"
                  type="textarea"
                  placeholder="请输入"
                  :autosize="{ minRows: 2, maxRows: 5}"
                  maxlength="2000"
                  style="height: 36px !important;"
                />
              </div>
              <!-- 时间 -->
              <div v-if="item.type === '4' || item.type === '14'">
                <el-date-picker
                  style="width:222px !important"
                  v-model="item.date"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  @change="selectChange1(item)"
                />
              </div>
              <!-- 单选 -->
              <div v-else-if="item.type === '6' || item.type === '8'">
                <!-- 任务状态:multiple="(item.optionsValue.prop === 'taskType' || item.optionsValue.prop === 'status') ? true : false" -->
                <div v-if="item.optionsValue.sysFlag === '1' && tabType !== '4'">
                  <!--  -->
                  <div v-if="item.optionsValue.prop === 'status'">
                    <el-select
                      v-model="item.date"
                      placeholder="请选择"
                      @change="selectChange1(item)"
                      multiple
                      collapse-tags
                      filterable
                    >
                      <el-option-group
                        v-for="group in item.optionsValue.options"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item1 in group.options"
                          :key="item1.value"
                          :label="item1.label"
                          :value="item1.value"
                        />
                      </el-option-group>
                    </el-select>
                  </div>
                  <div v-else>
                    <el-select
                      v-model="item.date"
                      placeholder="请选择"
                      @change="selectChange1(item)"
                      multiple
                      collapse-tags
                      filterable
                    >
                      <el-option
                        v-for="value in item.optionsValue.options"
                        :key="value.key"
                        :label="value.name"
                        :value="value.key"
                      />
                    </el-select>

                  </div>
                </div>
                <!-- 项目状态 -->
                <div v-else-if="item.optionsValue.sysFlag === '1' && tabType == '4'">
                  <el-select
                    v-model="item.date"
                    placeholder="请选择"
                    @change="selectChange1(item)"
                    multiple
                    collapse-tags
                    filterable
                  >
                    <el-option
                      v-for="value in item.optionsValue.options"
                      :key="value.key"
                      :label="value.name"
                      :value="value.key"
                    />
                  </el-select>
                </div>
                <div v-else>
                  <el-select
                    v-model="item.date"
                    placeholder="请选择"
                    @change="selectChange1(item)"
                    popper-class="selectStyle"
                    multiple
                    collapse-tags
                    filterable
                  >
                    <el-option
                      v-for="value in item.optionsValue.options"
                      :key="value.key"
                      :label="value.value"
                      :value="value.key"
                    />
                  </el-select>
                </div>
              </div>
              <!-- 多选 -->
              <div v-if="item.type === '7' || item.type === '9'">
                <el-select
                  v-model="item.date"
                  placeholder="请选择"
                  @change="selectChange1(item)"
                  popper-class="selectStyle"
                  multiple=""
                  collapse-tags
                  filterable
                >
                  <el-option
                    v-for="value in item.optionsValue.options"
                    :key="value.key"
                    :label="value.value"
                    :value="value.key"
                  />
                </el-select>
              </div>
              <div v-else-if="!item.type">
                <div class="input_box" />
              </div>
            </div>
            <!-- 加减 -->
            <div class="sele-icon">
              <i @click="delCond(index)" class="iconfont icon-checkbox-minus" />
              <i @click="addCond" class="iconfont icon-checkbox-plus" />
            </div>
          </div>
          <!-- 按钮 -->
          <div class="footer" v-if="!addButt">
            <div>
              <el-button @click="reset">清空</el-button>
              <el-button type="primary" @click="screening">确定</el-button>
            </div>
          </div>
        </div>
      </div>
      <div slot="reference" class="more_btn">
        <el-button :type="addButt ? 'info' : 'primary'" plain>
          <i class="iconfont icon-shaixuan-" style="font-size: 16px" />
          <span> 更多筛选 </span>
          <i class="el-icon-arrow-down el-icon--right" />
        </el-button>
      </div>
    </el-popover>
  </div>
</template>

<script>
import TagsList from '../tagsList.vue'
import { findLabelList, findProjectList } from '../../../utils/api/project'
import { findTaskMenuList, findProjectMenuList, findAllFrom } from '../../../utils/api/task'
import { findUserIds } from '../../../utils/api/user.js'
import { editChange } from '../../../utils/tag.js'
import { myFlowList, findFlowNodeList } from '../../../utils/api/process'
import choose from 'dingtalk-jsapi/api/biz/contact/choose' // PC 通讯录选人
import Vue from 'vue'
export default {
  directives: {
    'el-select-loadmore': (el, binding) => {
      // 获取element-ui定义好的scroll父元素
      const wrapEl = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
      if (wrapEl) {
        wrapEl.addEventListener('scroll', function() {
          if (this.scrollTop + this.clientHeight >= this.scrollHeight) {
            // binding的value就是绑定的loadmore函数
            binding.value()
          }
        })
      }
    }
  },
  components: { TagsList },
  props: {
    // 接受 参数
    state: {
      type: String,
      default: ''
    },
    // 筛选
    search: {
      type: Array,
      default: () => []
    },
    tabType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rangeNumber: 50,
      channel: JSON.parse(sessionStorage.getItem('loginUserData')).channel,
      tryOutType: JSON.parse(sessionStorage.getItem('loginUserData')).tryOutType,
      props: { multiple: true },
      flowList: [],
      fromList: [],
      proList: [],
      visible: false,
      // 点击添加按钮
      addButt: true,
      // 筛选
      searchJson: [],
      optionsKey: [],
      cascaderProps: {
        multiple: true,
        lazy: true,
        lazyLoad: this.lazyLoad,
        value: 'id',
        label: 'flowName',
        children: 'children'
      },
      cascaderValue: [],
      optionsKeyPro: [
        {
          value: 'principalUserIds',
          label: '负责人',
          select: true,
          multiple: false,
          fun: this.contactCh,
          userList: []
        },
        {
          value: 'manageUserIds',
          label: '管理员',
          select: true,
          multiple: true,
          fun: this.contactCh,
          userList: []
        },
        {
          value: 'status',
          label: '项目状态',
          select: false,
          multiple: true,
          fun: this.selectChange1,
          List: [
            {
              value: '0',
              label: '未开始'
            },
            {
              value: '1',
              label: '进行中'
            },
            {
              value: '2',
              label: '已完成'
            }
          ]
        },
        {
          value: 'label',
          label: '标签',
          select: true,
          multiple: true,
          List: [],
          labelList: []
        },
        {
          value: 'typeIds',
          label: '项目类型',
          select: false,
          multiple: true,
          List: [
            {
              value: '0',
              label: '标准类型'
            },
            {
              value: '2001',
              label: '敏捷类型'
            }
          ]
        },
        {
          value: 'kpi',
          label: '关联绩效',
          select: false,
          multiple: false,
          fun: this.selectChange1,
          List: [
            {
              value: '0',
              label: '否'
            },
            {
              value: '1',
              label: '是'
            }
          ]
        }
      ],
      optionsKeyTask: [
        {
          value: 'taskTypeStatus',
          label: '任务状态',
          select: false,
          multiple: true,
          List: [
            {
              value: '0',
              label: '标准类型',
              children: [
                {
                  value: '0_0',
                  label: '未指派'
                },
                {
                  value: '0_1',
                  label: '未完成'
                },
                {
                  value: '0_2',
                  label: '已完成'
                },
                {
                  value: '0_3',
                  label: '待确认'
                },
                {
                  value: '0_4',
                  label: '已终止'
                },
                {
                  value: '0_00',
                  label: '已逾期'
                }
              ]
            },
            {
              value: '1',
              label: '工作流程',
              children: [
                {
                  value: '1_1',
                  label: '未完成'
                },
                {
                  value: '1_2',
                  label: '已完成'
                },
                {
                  value: '1_4',
                  label: '已终止'
                },
                {
                  value: '1_00',
                  label: '已逾期'
                }
              ]
            },
            {
              value: '2001',
              label: '敏捷类型',
              children: [
                {
                  value: '2001_0',
                  label: '需求池'
                },
                {
                  value: '2001_1',
                  label: '开发中'
                },
                {
                  value: '2001_2',
                  label: '待测试'
                },
                {
                  value: '2001_3',
                  label: '测试中'
                },
                {
                  value: '2001_4',
                  label: '待验收'
                },
                {
                  value: '2001_5',
                  label: '验收完成'
                },
                {
                  value: '2001_6',
                  label: '已终止'
                },
                {
                  value: '2001_00',
                  label: '已逾期'
                }
              ]
            }
          ]
        },
        {
          value: 'label',
          label: '标签',
          select: true,
          multiple: true,
          List: [],
          labelList: []
        },
        {
          value: 'createBy',
          label: '创建人',
          select: true,
          multiple: true,
          fun: this.contactCh,
          userList: []
        },
        {
          value: 'responseUser',
          label: '负责人',
          select: true,
          multiple: true,
          fun: this.contactCh,
          userList: []
        },
        {
          value: 'confirmUser',
          label: '确认人',
          select: true,
          multiple: true,
          fun: this.contactCh,
          userList: []
        },
        {
          value: 'followUser',
          label: '关注人',
          select: true,
          multiple: true,
          fun: this.contactCh,
          userList: []
        },
        {
          value: 'executorUser',
          label: '执行人',
          select: true,
          multiple: true,
          fun: this.contactCh,
          userList: []
        },
        {
          value: 'producUser',
          label: '需求负责人',
          select: true,
          multiple: true,
          fun: this.contactCh,
          userList: []
        },
        {
          value: 'serviceUser',
          label: '开发负责人',
          select: true,
          multiple: true,
          fun: this.contactCh,
          userList: []
        },
        {
          value: 'testUser',
          label: '测试负责人',
          select: true,
          multiple: true,
          fun: this.contactCh,
          userList: []
        },
        {
          value: 'flow',
          label: '工作流程',
          select: false,
          multiple: true,
          fun: this.selectChange1,
          flowList: []
        },
        {
          value: 'currentNode',
          label: '当前节点',
          select: false,
          multiple: false,
          flowList: []
        },
        {
          value: 'kpi',
          label: '关联绩效',
          select: false,
          multiple: false,
          fun: this.selectChange1,
          List: [
            {
              value: '0',
              label: '否'
            },
            {
              value: '1',
              label: '是'
            }
          ]
        },
        {
          value: 'proIds',
          label: '项目',
          select: false,
          multiple: true,
          fun: this.selectChange1,
          proList: []
        },
        {
          value: 'createDate',
          label: '创建时间',
          select: false,
          multiple: false,
          fun: this.selectChange1,
          List: []
        },
        {
          value: 'planStartDate',
          label: '计划开始',
          select: false,
          multiple: false,
          fun: this.selectChange1,
          List: []
        },
        {
          value: 'planEndDate',
          label: '计划截止',
          select: false,
          multiple: false,
          fun: this.selectChange1,
          List: []
        },
        {
          value: 'realityStartDate',
          label: '实际开始',
          select: false,
          multiple: false,
          fun: this.selectChange1,
          List: []
        },
        {
          value: 'realityEndDate',
          label: '实际截止',
          select: false,
          multiple: false,
          fun: this.selectChange1,
          List: []
        }
      ],
      tagList: [],
      tags: false,
      tagsObject: {
        checkboxGroup: [],
        fun: this.checkboxGroupChange
      },
      dervalue: [],
      // 任务状态选项
      options: [{
        label: '',
        options: [{
          value: '0',
          label: '未指派'
        }, {
          value: '1',
          label: '未完成'
        }, {
          value: '2',
          label: '已完成'
        }, {
          value: '3',
          label: '待确认'
        }, {
          value: '4',
          label: '已终止'
        }, {
          value: '9',
          label: '已逾期'
        }
        ]
      }, {
        label: '敏捷任务',
        options: [{
          value: 'a',
          label: '需求池'
        }, {
          value: 'b',
          label: '开发中'
        }, {
          value: 'c',
          label: '待测试'
        }, {
          value: 'd',
          label: '测试中'
        },
        {
          value: 'e',
          label: '待验收'
        },
        {
          value: 'f',
          label: '验收完成'
        }]
      }],
      page: 1,
      pageSize: 100,
      pageNum: 1
    }
  },
  watch: {
    search: {
      handler() {
        if (this.search && this.search.length > 0) {
          this.searchJson = this.search.map(item => ({
            ...item,
            optionsKey: item.optionsKey || [], // 确保 optionsKey 有默认值
            key: item.key || '', // 确保 key 有默认值
            date: item.date || [], // 确保 date 有默认值
            value: item.value || '' // 确保 value 有默认值
          }))
          this.addButt = false
          this.getDate()
        } else {
          this.searchJson = []
          this.addButt = true
        }
      }
    }
  },
  mounted() {
    // this.getTabsList()
  },
  methods: {
    // 展开
    showPopver() {
      this.myProList()
      this.getTabsList()
      this.getFromList()
      this.getChoiceList().then(() => {
        // this.$nextTick(() => {
        //   this.flowList.forEach(flow => {
        //     this.lazyLoad1({
        //       level: 0,
        //       data: { id: flow.id }
        //     }, (nodes) => {
        //       flow.children = nodes
        //     })
        //   })
        // })
      })
      this.findTaskMenuList('')
    },
    // 数据
    getDate() {
      // this.searchJson.map((date) => {
      //   this.optionsKey.map((item) => {
      //     if (item.value === date.key) {
      //       date.optionsKey = this.optionsKey
      //       date.fun = item.fun
      //       date.select = item.select
      //       date.multiple = item.multiple
      //       date.List = item.List
      //       if (item.value === 'taskTypeStatus' && date.value !== '') {
      //         var list = date.value.split(',') || []
      //         var list_data = []
      //         list.map((item) => {
      //           list_data.push([item.split('_')[0], item])
      //         })
      //         date.date = list_data
      //       } else if (item.multiple && date.value !== '') {
      //         date.date = date.value.split(',') || []
      //       } else if (item.multiple && date.value === '') {
      //         date.date = []
      //       } else {
      //         date.date = date.value
      //       }
      //     }
      //   })
      // })
    },
    // 钉钉通讯录选人组件
    contactChoose(userids, type, key) {
      var that = this
      choose({
        multiple: true, // 是否多选：true多选 false单选； 默认true
        users: userids, // 默认选中的用户列表，员工userid；成功回调中应包含该信息
        corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId, // 企业id
        max: 100, // 人数限制，当multiple为true才生效，可选范围1-1500
        onSuccess: function(res) {
          if (res.length > 0) {
            var date = {
              users: res
            }
            // alert('数据 ' + JSON.stringify(date))
            findUserIds(date).then((res1) => {
              if (res1.code === 10000 && res1.result.isAll) {
                that.saveProUsers(res1.result.userList, type, key)
              } else {
                this.$message.warning(
                  res1.result.unAuthUserNameList.join(',') + ' 未授权'
                )
              }
            }).catch((error) => {
              console.log(error)
              //  this.$message.error('网络错误，请稍候！')
            })
          }
        },
        onFail: function(err) {
          console.log(err)
        }
      }).then((res) => {
        console.log('then______err', res)
        // alert('$ANTDD error: ' + JSON.stringify(err))
      }).catch((err) => {
        console.log('catch______err', err)
        // alert('$ANTDD error: ' + JSON.stringify(err))
      })
    },
    // 企微通讯录选人组件
    wechatLogin(userids, type, key) {
      var that = this
      if (this.tryOutType === '1') {
        Vue.prototype.$wx.invoke('selectPrivilegedContact', {
          'fromDepartmentId': -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          'mode': 'multi', // 必填，选择模式，single表示单选，multi表示多选
          'type': ['user'], // 必填，选择限制类型，指定department、user中的一个或者多个
          'selectedDepartmentIds': [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          'selectedUserIds': userids // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, function(res) {
          if (res.err_msg === 'selectPrivilegedContact:ok') {
            if (typeof res.result === 'string') {
              res.result = JSON.parse(res.result) // 由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            const selectedUserList = res.result.userList || [] // 已选的成员列表
            const selectedTicket = res.result.selectedTicket || '' // 已选的成员Ticket列表
            if (selectedUserList.length > 0 || selectedTicket.length > 0) {
              var date = {
                type: 'user',
                users: selectedUserList,
                ticket: selectedTicket
              }
              // alert('数据 ' + JSON.stringify(date))
              findUserIds(date).then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  that.saveProUsers(res1.result.userList, type, key)
                } else {
                  this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
                }
              }).catch((error) => {
                console.log(error)
              //  this.$message.error('网络错误，请稍候！')
              })
            }
          }
        })
      } else {
        Vue.prototype.$wx.invoke('selectEnterpriseContact', {
          'fromDepartmentId': -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          'mode': 'multi', // 必填，选择模式，single表示单选，multi表示多选
          'type': ['user'], // 必填，选择限制类型，指定department、user中的一个或者多个
          'selectedDepartmentIds': [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          'selectedUserIds': userids // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, function(res) {
          if (res.err_msg === 'selectEnterpriseContact:ok') {
            if (typeof res.result === 'string') {
              res.result = JSON.parse(res.result) // 由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            const selectedUserList = res.result.userList // 已选的成员列表
            if (selectedUserList.length > 0) {
              var date = {
                users: selectedUserList
              }
              // alert('数据 ' + JSON.stringify(date))
              findUserIds(date).then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  that.saveProUsers(res1.result.userList, type, key)
                } else {
                  this.$message.warning(
                    res1.result.unAuthUserNameList.join(',') + ' 未授权'
                  )
                }
              }).catch((error) => {
                console.log(error)
              //  this.$message.error('网络错误，请稍候！')
              })
            }
          }
        })
      }
    },
    // 添加项目负责人，管理员
    contactCh(principalUsers, item) {
      var userids = []
      principalUsers.map((item) => {
        userids.push(item.userid)
      })
      if (this.channel === 'ding') {
        this.contactChoose(userids, item.type, item.key)
      } else if (this.channel === 'wechat') {
        this.wechatLogin(userids, item.type, item.key)
      }
    },
    // 编辑项目负责人，管理员
    saveProUsers(res, type, key) {
      var userIds = []
      res.map((item) => {
        userIds.push(item.id)
      })
      this.searchJson.map((item, index) => {
        if (item.key === key) {
          item.date = userIds
          item.userList = res
          item.value = item.date.join(',')
          this.$forceUpdate()
        }
      })
    },
    // 所有表单
    getFromList() {
      var date = {
        formName: ''
      }
      findAllFrom(date).then((data) => {
        if (data.code === 10000) {
          this.fromList = data.result
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 我的流程
    getChoiceList() {
      var date = {
        flowName: ''
      }
      return myFlowList(date).then((data) => {
        if (data.code === 10000) {
          this.flowList = data.result
          data.result.map((item) => {
            item.children = []
          })
          if (Array.isArray(this.optionsKey)) {
            this.optionsKey.forEach((item) => {
              if (item.value === 'flowNames') {
                item.flowList = data.result
              }
            })
          }
          if (this.searchJson && Array.isArray(this.searchJson)) {
            this.searchJson.forEach((item) => {
              if (item.key === 'flowNames') {
                item.flowList = data.result
              }
            })
          }
        }
        return data
      }).catch((error) => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    // 项目
    myProList() {
      var date = {}
      findProjectList(date).then((data) => {
        if (data.code === 10000) {
          this.proList = data.result
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 点击添加按钮
    addBut() {
      this.addButt = false
    },
    loadMore() {
      console.log('加载更多')
      // this.page += 1
      // this.findTaskMenuList1()
      return () => (this.rangeNumber += 5)
    },
    // 过滤数据
    filterMethod(val, item) {
      this.findTaskMenuList(val, item.key)
    },
    findTaskMenuList(val, key) {
      var page = this.page
      var pageSize = this.pageSize
      var date = {
        objectId: '',
        type: this.tabType,
        searchName: val
      }
      if (this.tabType === '4') {
        findProjectMenuList(page, pageSize, date).then((data) => {
          if (data.code === 10000) {
            const list = [...data.result.checkList, ...data.result.uncheckPageList.list]
            var filterList = list.filter(item =>
              !(item.type === '3' || item.prop === 'proNumber' || item.prop === 'proname' || item.prop === 'versionName' || item.searchFlag !== '1')
            )
            if (!date.searchName) {
              this.optionsKey = filterList
            } else {
              filterList = filterList.filter((item) => {
                return item.label && item.label.indexOf(date.searchName) > -1
              })
            }
            if (this.searchJson && this.searchJson.length === 0) {
              this.searchJson.push({
                key: '',
                value: '',
                type: '',
                date: [],
                List: [],
                flowList: [],
                proList: [],
                optionsValue: {},
                optionsKey: filterList
              })
            } else {
              if (val) {
                this.searchJson.map((item) => {
                  if (item.key === key) {
                    item.optionsKey = filterList
                  }
                })
              } else {
                this.search.map((item) => {
                  item.optionsKey = filterList
                })
                this.searchJson = this.search
              }
            }
          } else {
            this.$message.warning(data.info)
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        findTaskMenuList(page, pageSize, date).then((data) => {
          if (data.code === 10000) {
            const list = [...data.result.checkList, ...data.result.uncheckPageList.list]
            var filterList = list.filter(item =>
              !(item.prop === 'taskNumber' || item.prop === 'taskname' || item.type === '3' || item.prop === 'versionName' || item.searchFlag !== '1')
            )
            filterList.map((itemf) => {
              if (itemf.prop === 'status') {
                itemf.options = this.options
              }
            })
            if (!date.searchName) {
              this.optionsKey = filterList
            } else {
              filterList = filterList.filter((item) => {
                return item.label && item.label.indexOf(date.searchName) > -1
              })
            }
            this.pageNum = data.result.uncheckPageList.pages
            if (this.searchJson && this.searchJson.length === 0) {
              this.searchJson.push({
                key: '',
                value: '',
                type: '',
                date: [],
                List: [],
                flowList: [],
                proList: [],
                optionsValue: {},
                optionsKey: filterList
              })
            } else {
              if (val) {
                this.searchJson.map((item) => {
                  item.optionsKey = filterList
                })
              } else {
                this.search.map((item) => {
                  item.optionsKey = filterList
                })
                this.searchJson = this.search
              }
            }
          } else {
            this.$message.warning(data.info)
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    // 点击加号
    addCond() {
      var SortingType = false
      this.searchJson.map((date) => {
        if (date.key !== '') {
          this.optionsKey.map((item, index) => {
            if (item.prop === date.key) {
              this.optionsKey.splice(index, 1)
            }
          })
        } else {
          SortingType = true
          this.$message.warning('请先选择筛选类型')
        }
      })
      if (this.optionsKey.length > 0 && !SortingType) {
        this.searchJson.push({
          key: '',
          type: '',
          value: '',
          date: [],
          List: [],
          flowList: [],
          proList: [],
          optionsValue: {},
          optionsKey: this.optionsKey
        })
      }
    },
    // 获取焦点
    focusChange(row) {
      this.searchJson.map((date) => {
        row.optionsKey.map((item, index) => {
          if (item.value === date.key && row.key !== date.key) {
            row.optionsKey.splice(index, 1)
          }
        })
      })
    },
    // key选中
    selectChange(row, e) {
      for (let i = 0; i < row.optionsKey.length; i++) {
        if (row.optionsKey[i].prop === e) {
          row.type = row.optionsKey[i].type
          row.optionsValue = row.optionsKey[i]
        }
      }
      row.value = ''
      row.date = []
      row.userList = []
      row.labelList = []
      row.proList = []
      row.versionList = []
      // this.getDate()
      this.getTabsList()
      // 当前节点
      if (row.key === 'flowNames') {
        this.getChoiceList()
      }
    },
    // value选中1
    selectChange1(row) {
      console.log(row, 'row')
      if (row.key === 'taskTypeStatus') {
        // row.value = row.date.join(',')
        var list = row.date || []
        var date = []
        list.map((item) => {
          item.map((data_item, index1) => {
            if (index1 === 1) {
              date.push(data_item)
            }
          })
        })
        row.value = date.join(',')
      } else if (row.type === '1' || row.type === '16') {
        row.value = row.date
      } else if (row.key === 'flowNames') {
        row.value = row.date
      } else if (row.multiple && row.date.length > 0) {
        row.value = row.date.join(',')
      } else {
        row.value = row.date
      }
    },
    // 获取所有子节点
    lazyLoad(node, resolve) {
      const level = node.level
      if (level === 0 || level === 1) {
        var date = {
          flowId: node.data?.id
        }
        findFlowNodeList(date).then((data) => {
          if (data.code === 10000) {
            const res = data.result.map(item => ({
              id: item.id,
              flowName: item.nodeName,
              flowId: item.flowId
            }))
            const nodes = res
            this.searchJson.map((item) => {
              if (item.key === 'flowNames') {
                item.flowList.map((itemC) => {
                  data.result.map((itemK) => {
                    if (itemC.id === itemK.flowId) {
                      itemC.children = nodes
                    }
                  })
                })
              }
            })
            this.optionsKey.map((itemF) => {
              if (itemF.value === 'flowNames') {
                itemF.flowList.map((itemC) => {
                  data.result.map((itemK) => {
                    if (itemC.id === itemK.flowId) {
                      itemC.children = nodes
                    }
                  })
                })
              }
            })
            resolve(nodes)
          } else {
            this.$message.error(data.info)
          }
        }).catch((err) => {
          console.log(err)
        })
      } else if (level === 2) {
        let data
        resolve(data)
        return
      }
    },
    // 可添加缓存避免重复加载
    lazyLoad1(node, resolve) {
      if (node.data._loaded) { // 检查缓存标志
        resolve(node.data.children || [])
        return
      }
      findFlowNodeList({ flowId: node.data.id }).then(data => {
        // const nodes = data.result.map(item => ({
        //   ...item,
        //   _loaded: false // 标记未加载子子节点
        // }))
        if (data.code === 10000) {
          const res = data.result.map(item => ({
            id: item.id,
            flowName: item.nodeName,
            flowId: item.flowId
          }))
          const nodes = res
          this.searchJson.map((item) => {
            if (item.flowList && item.flowList.length > 0) {
              item.flowList.map((itemC) => {
                data.result.map((itemK) => {
                  if (itemC.id === itemK.flowId) {
                    itemC.children = nodes
                  }
                })
              })
            }
          })
          this.flowList.map((k) => {
            data.result.map((itemK) => {
              if (k.id === itemK.flowId) {
                k.children = nodes
              }
            })
          })
          this.optionsKey.map((itemF) => {
            if (itemF.value === 'flowNames') {
              itemF.flowList.map((itemC) => {
                data.result.map((itemK) => {
                  if (itemC.id === itemK.flowId) {
                    itemC.children = nodes
                  }
                })
              })
            }
          })
          console.log(this.flowList, '记已加载')
          resolve(nodes)
        } else {
          this.$message.error(data.info)
        }
        // console.log(this.searchJson, '记已加载')
        // node.data._loaded = true // 标记已加载
        // node.data.children = nodes // 更新数据

        // resolve(nodes)
      })
    },
    // 点击减号
    delCond(index) {
      if (this.searchJson.length > 1) {
        this.searchJson.splice(index, 1)
      } else {
        this.searchJson = []
        this.addButt = true
        this.$emit('searchJson', this.searchJson)
      }
    },
    // 取消筛选
    reset() {
      // if (this.search && this.search.length > 0) {
      //   this.searchJson = this.search
      //   this.addButt = false
      // } else {
      //   this.searchJson = []
      //   this.addButt = true
      // }
      this.searchJson = []
      this.addButt = true
      this.visible = false
      this.$emit('searchJson', this.searchJson)
    },
    // 确定筛选
    screening() {
      // 类型
      var SortingType = false
      this.searchJson.map((date) => {
        console.log(date, 'date')
        if (date.key === '' || date.value === '') {
          SortingType = true
          this.$message.warning('筛选条件不能为空')
        }
      })
      console.log(this.searchJson, 'this.searchJson')
      if (!SortingType) {
        this.visible = false
        this.$emit('searchJson', this.searchJson)
      }
    },
    // 标签点击事件
    labelChange(date) {
      this.tags = true
      this.tagsObject.checkboxGroup = date
    },
    // 编辑项目标签
    checkboxGroupChange(date) {
      var labelList = editChange(this.tagList, date)
      this.searchJson.map((item, index) => {
        if (item.key === 'labelList') {
          item.date = date
          item.labelList = labelList
          this.$forceUpdate()
          if (item.multiple && item.date.length > 0) {
            item.value = item.date.join(',')
          } else {
            item.value = item.date
          }
        }
      })
    },
    // 项目标签列表
    getTabsList() {
      findLabelList().then((data) => {
        if (data.code === 10000) {
          // this.optionsKeyPro[3].List = data.result
          this.tagList = data.result
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 标签透明度
    convertHex(hex, opacity) {
      hex = hex?.replace('#', '')
      var r = parseInt(hex?.substring(0, 2), 16)
      var g = parseInt(hex?.substring(2, 4), 16)
      var b = parseInt(hex?.substring(4, 6), 16)
      var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/index.scss';
.lyout {
  .main {
    margin: 10px 0;
    height: 200px;
    overflow-y: auto;
    .main-first {
      margin-top: 8px;
      display: flex;
      .sele-fist {
        width: 160px;
        height: 36px;
        margin-left: 23px;
      }
      .sele-secon {
        width: 230px;
        height: 36px;
        line-height: 36px;
        margin-left: 12px;
      }
      .iconfont {
        font-size: 24px;
        line-height: 44px;
        margin: 0 12px;
        &:hover {
          color: $color_main;
          cursor: pointer;
        }
      }
    }
  }
  ::v-deep .el-cascader {
    line-height: 32px;
  }
  ::v-deep .el-cascader__search-input {
    display: none;
  }
  ::v-deep .el-select .el-input .el-select__caret {
    line-height: 36px;
  }
  ::v-deep .el-select__tags {
    height: 24px;
  }
  ::v-deep .el-input .el-input__inner {
    height: 36px !important;
    line-height: 36px;
  }
  ::v-deep .el-cascader .el-input .el-input__inner {
    height: 36px !important;
    width: 222px;
    line-height: 36px;
  }
  ::v-deep .el-cascader__tags {
    height: 24px;
  }
  .footer {
    position: absolute;
    left: 356px;
    bottom: 15px;
    .el-button {
      width: 73px;
      height: 36px;
    }
    .el-button--primary {
      color: $color_white;
      background: $color_main;
      border-color: $color_main;
    }
  }
}
.input_box {
  width: 222px;
  height: 34px;
  line-height: 34px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.input {
  width: 166px;
  height: 36px;
  margin: 0 15px;
  line-height: 36px;
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
}
.more_btn .el-button--primary.is-plain {
  color: $color_main;
  border-color: $color_main;
  background: rgba(40, 120, 255, 0.1);
}
.more_btn .el-button:focus,
.more_btn .el-button:hover {
  color: $color_main;
  border-color: $color_main;
  background: rgba(40, 120, 255, 0.1);
}
.sea-icon {
  padding: 0 5px;
}
.el-button {
  height: 36px;
  line-height: 0;
}
.cond {
  width: 100%;
  .el-button {
    width: 100%;
  }
}
::v-deep .el-popover {
  padding: 0;
}
::v-deep.el-select-dropdown ::v-deep.el-scrollbar{
  width: 220px !important;
}
// /deep/ .el-select-dropdown__list {
//   overflow: hidden;
//     text-overflow: ellipsis;
//     white-space: nowrap;
//     width: 150px !important;
// }
.el-select-dropdown .el-scrollbar{
  width: 220px !important;
}
::v-deep .el-cascader-panel{
  height: 230px !important;
}
.flowName {
  .el-cascader-panel {
    .el-scrollbar:first-child {
      .el-checkbox {
        display: none !important;
      }
    }
  }
}
.node{
  ::v-deep .el-cascader-menu:nth-child(2){
    ::v-deep [class*=" el-icon-"], [class^=el-icon-]{
    display: none !important;
  }

}}
.node{
  ::v-deep .el-cascader-menu:nth-of-type(3){
    display: none !important;
}}
.input-area{
  ::v-deep.el-input__inner{
  height: 36px !important;
}
::v-deep .el-textarea__inner{
  height: 36px !important;
  min-height: 36px !important;
}
}
.felx{
    height: 36px;
    line-height: 36px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
  ::v-deep.el-input__inner {
    border: none !important;
  }
}
</style>
<style>
.el-popover.my-popover {
  padding: 0;
  height: 280px;
  position: relative;
}
/* .el-scrollbar__wrap {
  width: 222px !important;
}
.el-select-dropdown__list {
  overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
} */
.el-cascader-menu__list{
  /* height: 360px !important; */
}
.el-cascader-menu {
  height: 320px;
}
.node.el-cascader-panel .el-cascader-menu .el-cascader-node__postfix {
  display: none !important;
}
</style>
